<div class="padding">
    <h2 mat-dialog-title>{{data.title}}</h2>
    <mat-dialog-content>{{data.confirmationPrompt}}</mat-dialog-content>
    <mat-dialog-actions align="end">
        @if (data.positiveResponseLabel){
            <button mat-raised-button [color]="this.positiveResponseColor" [mat-dialog-close]="true"
                data-testid="positive-dialog-button">{{data.positiveResponseLabel}}</button>
        }
        @if (data.negativeResponseLabel){
            <button mat-raised-button [color]="this.negativeResponseColor" mat-dialog-close
                data-testid="negative-dialog-button">{{data.negativeResponseLabel}}</button>
        }
    </mat-dialog-actions>
</div>